"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalBigImageNewsWhite(t0) {
  const $ = _c(52);
  const {
    title: t1,
    excerpt: t2,
    timeAgo: t3,
    imageSrc: t4,
    slug,
    priority: t5,
    imageMetadata
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "'\u0B95\u0B9F\u0BBF\u0BA9 \u0B95\u0BA4\u0BCB\u0BB0\u0BBF \u0B85\u0BA3\u0BCD\u0B9F\u0B95\u0B9F\u0BB9\u0BAE\u0BCD' \u0BA4\u0BBF\u0BB0\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F \u0BB5\u0BBF\u0BAE\u0BB0\u0BCD\u0B9A\u0BA9\u0BAE\u0BCD: \u0BB5\u0BC6\u0B95\u0BC1 \u0BA4\u0BCA\u0BA9\u0BB2\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0B87\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B95\u0B9F\u0BA8\u0BCD\u0BA4 \u0B95\u0BBE\u0BB2\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B89\u0BA3\u0BB0\u0BCD\u0B9A\u0BCD\u0B9A\u0BBF\u0BAF\u0BC8",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const title = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "\u0BA8\u0BBE\u0B9F\u0BCD\u0B9F\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B89\u0BB1\u0BCD\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF 2023 \u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BBF\u0BB2\u0BCD 8.5 \u0B9A\u0BA4\u0BB5\u0BC0\u0BA4\u0BAE\u0BCD \u0B85\u0BA4\u0BBF\u0B95\u0BB0\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 7.314 \u0B95\u0BCB\u0B9F\u0BBF \u0B9F\u0BA9\u0BCD\u0BA9\u0BBE\u0B95",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const excerpt = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "15 min ago",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const timeAgo = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const imageSrc = t9;
  const priority = t5 === undefined ? false : t5;
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  let t10;
  if ($[8] !== imageSrc?.value) {
    t10 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[8] = imageSrc?.value;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const imageSrcValue = t10;
  const t11 = timeAgo?.value;
  let t12;
  if ($[10] !== t11) {
    t12 = getTimeAgo(t11);
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const timeAgoValue = t12;
  let t13;
  if ($[12] !== imageMetadata || $[13] !== imageSrc?.customClass || $[14] !== imageSrc?.hidden || $[15] !== imageSrcValue || $[16] !== priority || $[17] !== titleValue) {
    t13 = !imageSrc?.hidden && <div className={`shrink-0 ${imageSrc?.customClass || ""}`}><div className="relative w-[106px] h-[56px] md:w-[150px] md:h-[110px] lg:w-[180px] lg:h-[114px] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} sizes="(max-width: 768px) 100px, 300px" loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} priority={priority} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[12] = imageMetadata;
    $[13] = imageSrc?.customClass;
    $[14] = imageSrc?.hidden;
    $[15] = imageSrcValue;
    $[16] = priority;
    $[17] = titleValue;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== title?.customClass || $[20] !== title?.hidden || $[21] !== titleValue) {
    t14 = !title?.hidden && <h3 className={`text-14-tamil-700 md:text-14-tamil-700 text-FFFFFF font-medium leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[19] = title?.customClass;
    $[20] = title?.hidden;
    $[21] = titleValue;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== excerpt?.customClass || $[24] !== excerpt?.hidden || $[25] !== excerptValue) {
    t15 = !excerpt?.hidden && <p className={`text-11-tamil-400 md:text-12-tamil-400 text-FFFFFF leading-[1.5] line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[23] = excerpt?.customClass;
    $[24] = excerpt?.hidden;
    $[25] = excerptValue;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <div className="flex flex-col gap-3">{t14}{t15}</div>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== timeAgo?.customClass || $[31] !== timeAgo?.hidden || $[32] !== timeAgoValue) {
    t17 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-FFFFFF ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[30] = timeAgo?.customClass;
    $[31] = timeAgo?.hidden;
    $[32] = timeAgoValue;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const t18 = slug ? `/${slug}` : undefined;
  let t19;
  if ($[34] !== excerptValue || $[35] !== imageSrcValue || $[36] !== slug || $[37] !== t18 || $[38] !== titleValue) {
    t19 = <MessageIcon id="small-image-news-vert-message-icon" variant="message-icon-4" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t18} />;
    $[34] = excerptValue;
    $[35] = imageSrcValue;
    $[36] = slug;
    $[37] = t18;
    $[38] = titleValue;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t17 || $[41] !== t19) {
    t20 = <div className="mt-3"><div className="flex items-center justify-between">{t17}{t19}</div></div>;
    $[40] = t17;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t16 || $[44] !== t20) {
    t21 = <div className="flex flex-col justify-between w-full">{t16}{t20}</div>;
    $[43] = t16;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t13 || $[47] !== t21) {
    t22 = <article className="bg-transparent overflow-hidden p-4 mb-0"><div className="flex flex-row gap-4">{t13}{t21}</div></article>;
    $[46] = t13;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  const content = t22;
  if (slug) {
    const t23 = `/${slug}`;
    let t24;
    if ($[49] !== content || $[50] !== t23) {
      t24 = <Link href={t23} className="block  transition-opacity cursor-pointer">{content}</Link>;
      $[49] = content;
      $[50] = t23;
      $[51] = t24;
    } else {
      t24 = $[51];
    }
    return t24;
  }
  return content;
}